import { createContext, useContext } from 'react';
import { fmt, compact } from './format';

export const NumberFormatContext = createContext('en-US');
export function useNumberFormat() {
  const locale = useContext(NumberFormatContext);
  return {
    locale,
    fmt: (value, unit, currency, opts = {}) => fmt(value, unit, currency, { ...opts, locale }),
    compact: (value, currency) => compact(value, currency, locale),
  };
}